// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketSystemItemSelectionChange, basketSystemItemSelectionReset } from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';

import BasketCombinationsSelector from './BasketCombinationsSelector';
import selectBasketCombinationsSelectorProps from './BasketCombinationsSelector.selector';

type BasketCombinationsSelectorContainerProps = {
  className?: string;
  readOnly?: boolean;
  onSubmit?: (...params: unknown) => unknown;
};

const BasketCombinationsSelectorContainer = (ownProps: BasketCombinationsSelectorContainerProps) => {
  const { readOnly } = ownProps;
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ readOnly }), [readOnly]);
  const selectedProps = useSelector((state) => selectBasketCombinationsSelectorProps(state, selectorProps));

  const onToggleSelection = useCallback(
    (key, selected) => {
      dispatch(basketSystemItemSelectionChange({ key, selected }));
    },
    [dispatch],
  );
  const onReset = useCallback(
    () => (!readOnly ? dispatch(basketSystemItemSelectionReset()) : null),
    [readOnly, dispatch],
  );

  const otherProps = useMemo(
    () => ({
      onToggleSelection,
      onReset,
    }),
    [onReset, onToggleSelection],
  );

  const enhancedProps = useMergeProps({ selectedProps, otherProps, ownProps });

  return <BasketCombinationsSelector {...enhancedProps} />;
};

export default BasketCombinationsSelectorContainer;
